import React, { useRef } from 'react';
import { useLocation } from 'react-router-dom'
import { inject, observer } from 'mobx-react';
import DataGrid, {
    Column,
    HeaderFilter,
    Lookup
} from 'devextreme-react/data-grid';
import { Template } from 'devextreme-react/core/template';
import { createStore } from 'devextreme-aspnet-data-nojquery';

import apiUrls from '../../common/api/api-urls';
import { trans } from '../../common/utils';
import { languages } from '../../configs/i18n';
import { setUnactiveRows } from '../../common/utils';
import {
    LanguageTemplate,
    dataGridDefaultSettings,
} from '../../components';

const ServicePage = ({
    store: {
        languages: { table },
    },
}) => {
    const ref = useRef();

    return (
        <>
            <DataGrid
                ref={ref}
                {...dataGridDefaultSettings({
                    settingStorageName: 'BMA_grid_info_service_USERID',
                    url: apiUrls.info.service,
                    key: 'serviceId',
                    language: languages.languageId[table],
                    languagePicker: false,
                    toolbarCenter: `${useLocation().pathname}`,
                    //toolbarAfter: {
                    //    template: 'todayFilter',
                    //    location: 'after',
                    //},
                    editing: {
                        allowAdding: true,
                        allowUpdating: true,
                        allowDeleting: false,
                    },
                })}
                onRowPrepared={setUnactiveRows}
            >
                <HeaderFilter visible={true} allowSearch={true} />

                <Column
                    dataField={'serviceId'}
                    caption={trans('ID')}
                    dataType={'number'}
                    width={100}
                    sortOrder={'asc'}
                    allowFixing={false}
                    allowHiding={false}
                    showInColumnChooser={false}
                    allowSearch={false}
                    allowEditing={true}
                    allowHeaderFiltering={false}
                />

                <Column
                    dataField={'paymentServiceProviderId'}
                    caption={trans('Провайдер для оплаты')}
                    dataType={'number'}
                    width={120}
                >
                    <Lookup
                        dataSource={createStore({
                            key: 'key',
                            loadUrl: apiUrls.lookup.serviceProvider,
                            onBeforeSend: (method, ajaxOptions) => {
                                //ajaxOptions.data.languageid = 1;
                                ajaxOptions.xhrFields = {
                                    withCredentials: true,
                                };
                            },
                        })}
                        displayExpr={'value'}
                        valueExpr={'key'}
                    />
                </Column>

                <Column
                    dataField={'pid'}
                    caption={trans('Родитель')}
                    dataType={'number'}
                    width={150}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                    allowEditing={true}
                    allowHiding={true}
                    showInColumnChooser={true}
                >
                    <Lookup
                        dataSource={createStore({
                            key: 'key',
                            loadUrl: apiUrls.lookup.parentServices,
                            onBeforeSend: (method, ajaxOptions) => {
                                //ajaxOptions.data.languageid = 1;
                                ajaxOptions.xhrFields = {
                                    withCredentials: true,
                                };
                            },
                        })}
                        displayExpr={'value'}
                        valueExpr={'key'}
                        allowClearing={true}
                    />
                </Column>/>

                <Column
                    dataField={'name'}
                    caption={trans('Название')}
                    dataType={'string'}
                    allowFixing={false}
                    width={250}
                    allowEditing={true}
                    allowHeaderFiltering={false}
                />

                <Column
                    dataField={'terminalMinSum'}
                    caption={trans('Мин сумма (терминал)')}
                    dataType={'number'}
                    width={150}
                    allowFixing={false}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                />
                <Column
                    dataField={'terminalMaxSum'}
                    caption={trans('Макс сумма (терминал)')}
                    dataType={'number'}
                    width={150}
                    allowFixing={false}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                />

                <Column
                    dataField={'onlineMinSum'}
                    caption={trans('Мин сумма (онлайн)')}
                    dataType={'number'}
                    width={150}
                    allowFixing={false}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                />

                <Column
                    dataField={'onlineMaxSum'}
                    caption={trans('Макс сумма (онлайн)')}
                    dataType={'number'}
                    width={150}
                    allowFixing={false}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                />

                <Column
                    dataField={'sortOrder'}
                    caption={trans('Сортировка')}
                    dataType={'number'}
                    width={120}
                    allowFixing={false}
                    allowSearch={false}
                    allowEditing={true}
                    allowHeaderFiltering={false}
                    allowHiding={true}
                    showInColumnChooser={true}
                />

                <Column
                    dataField={'isFixedPrice'}
                    caption={trans('Цена фиксированная?')}
                    dataType={'boolean'}
                    width={100}
                    allowSearch={false}
                />

                <Column
                    dataField={'websiteVisible'}
                    caption={trans('На сайте?')}
                    dataType={'boolean'}
                    width={100}
                    allowSearch={false}
                />

                <Column
                    dataField={'website2Visible'}
                    caption={trans('На сайте 2?')}
                    dataType={'boolean'}
                    width={100}
                    allowSearch={false}
                />

                <Column
                    dataField={'accountRegex'}
                    caption={trans('Regex аккаунта')}
                    dataType={'string'}
                    allowFixing={false}
                    width={150}
                    allowEditing={true}
                    allowHeaderFiltering={false}
                />

                <Column
                    dataField={'accountText'}
                    caption={trans('Текст аккаунта')}
                    dataType={'string'}
                    allowFixing={false}
                    width={150}
                    allowEditing={true}
                    allowHeaderFiltering={false}
                />


                <Column
                    dataField={'idt'}
                    caption={trans('Дата вставки')}
                    dataType={'datetime'}
                    format={'dd/MM/yyyy HH:mm:ss'}
                    width={150}
                    visible={false}
                    allowFixing={false}
                    allowEditing={false}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                    visible={false}
                    allowHiding={true}
                    showInColumnChooser={true}
                />
                <Column
                    caption={''}
                    visible={true}
                    allowFixing={false}
                    allowEditing={false}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                    allowHiding={false}
                    allowReordering={false}
                />

                <Template
                    name={'languageBar'}
                    render={() => <LanguageTemplate />}
                />

            </DataGrid>
        </>

    );
};

export default inject('store')(observer(ServicePage));
